module.exports = __webpack_public_path__ + "images/emoji/smiling_imp.d1ce066f87485d4eb857.png";